var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sort",class:_vm.clazz},[_c('i',{staticClass:"banana banana-triangle-up",attrs:{"aria-hidden":"true"},on:{"click":_vm.onUpIconClick}}),_c('i',{staticClass:"banana banana-triangle-down",attrs:{"aria-hidden":"true"},on:{"click":_vm.onDownIconClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }